export default __webpack_public_path__ + "static/sway-2-cd8759f6c4a232a0d1e666d5dbab4ab4.jpg";